@if (main$ | async; as main) {
  <div class="bg-light">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-sm-6 col-lg-12">
          <wl-category-filter [rendering]="rendering"></wl-category-filter>
        </div>
        @if (hasSubcategoryFilter$ | async) {
          <div class="col-12 col-sm-6 d-lg-none">
            <wl-subcategory-filter
              [rendering]="rendering"
            ></wl-subcategory-filter>
          </div>
        }
      </div>
    </div>
  </div>

  <div class="container">
    <div class="row">
      <div class="col">
        <div
          sc-placeholder
          wlAutomationId="knowledgebase-detail"
          name="body"
          class="py-4 content-item"
          [rendering]="rendering"
        ></div>
      </div>
      @if (hasSubcategoriesOrNoArticles$ | async) {
        <div class="col d-none d-lg-block col-md-3">
          @if (hasSubcategoryFilter$ | async) {
            <wl-subcategory-filter
              [rendering]="rendering"
            ></wl-subcategory-filter>
          }
        </div>
      }
    </div>
  </div>
}
